// project import
import dashboard from './dashboard';
import reports from './reports';
import tenants from './tenants';
import admin from './admin';
import incentives from './incentives';
import platform from './platform';
//import pages from './page';
//import utilities from './utilities';
//import support from './support';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, reports, tenants, admin, incentives, platform] //pages, utilities, support]
};

export default menuItems;
